<script setup lang="ts">
import OverlayPanel from 'primevue/overlaypanel'

defineProps({
  overlayClass: {
    type: String,
    default: ''
  }
})

const { public: { authHost } } = useRuntimeConfig()

const overlayRef = ref<OverlayPanel>()
const overlayOpen = ref(false)
const { clearSession, userInfo } = useUserInfo()

onMounted(() => {
  window.addEventListener('scroll', () => {
    if (overlayOpen.value) {
      overlayRef.value?.hide()
    }
  })
})

const logout = async () => {
  const accessToken = getCookie('access_token')
  await clearSession(true)
  navigateTo(authHost + '/oauth/client_logout?token=' + accessToken, { external: true })
}
</script>
<template>
  <button
    tabindex="0"
    class="flex items-center p-2 space-x-2 transition-colors focus:text-brand-mustard-500 no-focus-effect"
    :class="{
      'text-black hover:text-brand-mustard-500': !overlayOpen,
      'text-brand-mustard-500': overlayOpen
    }"
    @click="(evt) => overlayRef?.toggle(evt)"
  >
    <ISingleNeutralCircle
      class="hidden w-6 h-6 md:block"
    />
    <ISingleNeutral class="w-6 h-6 md:hidden" />
    <IArrowDown
      class="hidden w-2 h-2 md:block"
    />
  </button>
  <OverlayPanel
    ref="overlayRef"
    append-to="body"
    :pt="{
      root: 'bg-white shadow p-4 rounded w-48 mt-2',
      content: 'flex flex-col space-y-3'
    }"
    :class="overlayClass"
    @show="overlayOpen = true"
    @hide="overlayOpen = false"
  >
    <span class="text-[12px] font-bold">
      Angemeldet als {{ userInfo.first_name }}
    </span>
    <a :href="`${authHost}/user/account`" class="text-[16px] hover:font-bold hover:text-brand-mustard-500">
      Profil
    </a>
    <RouterLink
      to="/"
      class="text-[16px] hover:font-bold hover:text-brand-mustard-500"
      exact-active-class="font-bold"
    >
      Abonnements
    </RouterLink>
    <a href="https://ofjus.ch/shop" target="_blank" class="text-[16px] hover:font-bold hover:text-brand-mustard-500 flex items-center gap-2">
      <span>Zum Online Shop</span>
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 8L12.625 2.375" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.625 6.3105V2.375H8.625" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6.0625 4.875H1.8125C1.69647 4.875 1.58519 4.92109 1.50314 5.00314C1.42109 5.08519 1.375 5.19647 1.375 5.3125V13.1875C1.375 13.3035 1.42109 13.4148 1.50314 13.4969C1.58519 13.5789 1.69647 13.625 1.8125 13.625H9.6875C9.80353 13.625 9.91481 13.5789 9.99686 13.4969C10.0789 13.4148 10.125 13.3035 10.125 13.1875C10.125 13.1875 10.125 10.9878 10.125 8.9375" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </a>
    <div class="w-full border-b border-[#999]" />
    <a class="cursor-pointer text-[16px] hover:font-bold hover:text-brand-mustard-500" @click.prevent="logout">
      Abmelden
    </a>
  </OverlayPanel>
</template>
